import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, ConfirmEventType, MessageService } from 'primeng/api';
import { DocumentServiceGateway } from 'src/app/application/gateway/DocumentServiceGateway';
import { ImportOrderGateway } from 'src/app/application/gateway/ImportOrderGateway';
import { OperationDocumentTypeGateway } from 'src/app/application/gateway/OperationDocumentTypeGateway';
import { ImportOrderDocumentService } from 'src/app/application/service/ImportOrderDocumentService';
import { OperationService } from 'src/app/application/service/OperationService';
import { QualityControlReviewService } from 'src/app/application/service/QualityControlReviewService';
import { DocumentValidationResult, Hit, KeywordResults } from 'src/app/domain/models/DocumentValidationResult';
import { ImportOrderInformation } from 'src/app/domain/models/ImportOrder';
import { OperationAssignDocumentsRead, OperationDocumentType, OperationDocumentUpdateDescription, OperationInformation, UploadOperationFileRequest } from 'src/app/domain/models/Operation';
import { OperationDocument } from 'src/app/domain/models/OperationDocument';
import { DocumentEmailReads } from 'src/app/domain/models/DocumentEmailRead';
import { Routes } from 'src/app/infrastructure/routes';


interface UploadFile {
  type: number;
  name: string;
}

interface UploadEvent {
  originalEvent: Event;
  files: File[];
}

@Component({
  selector: 'app-admin-operation',
  templateUrl: './admin-operation.component.html',
  styleUrls: ['./admin-operation.component.css'],
  providers: [ConfirmationService]
})
export class AdminOperationComponent implements OnInit {

  orderGuid: any | undefined
  orderId: number | undefined
  uploadedFiles: any[] = []
  loading: boolean = false
  name: string = ""
  names: string[] = []
  documentTypeId: string = ""
  order: ImportOrderInformation | undefined
  visibleFilesModal: boolean = false
  visibleKeywordResult: boolean = false
  visibleDocumentAssignModal: boolean = false
  documentTypes: {index: number, documentTypeId: number}[] = []
  selectedDocumentsWithTypes: Array<{documentId: number, documentTypeId: number}> = []

  results: Hit[] = [];
  selectedDocumentResult: DocumentValidationResult | null = null;
  log: string | null = null;

  operationDocumentTypes: OperationDocumentType[] = []

  files: UploadFile[] = [
    { type: 5, name:'Instructivo'},
    { type: 0, name:'Factura de exportación'},
    { type: 3, name:'Certificado fitosanitario'},
    { type: 1, name:'BL'},
    { type: 4, name:'Certificado de origen'},
    { type: 6, name:'Booking'},
  ]

  selectedUploadFile: UploadFile = { type: 5, name:'Instructivo'};

  operationInformation: OperationInformation | undefined;
  documents: OperationDocument[] = []
  documentsHistory: OperationDocument[] = []

  tabActiveIndex: number = 0;

  constructor( private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _operationService: OperationService,
    private _messageService: MessageService,
    public translate: TranslateService,
    private _operationDocumentTypeService: OperationDocumentTypeGateway,
    private _importOrderDocumentService: ImportOrderDocumentService,
    private _documentService: DocumentServiceGateway,
    private _confirmationService: ConfirmationService,
    private _importOrderService: ImportOrderGateway,
    private _qualityControlReviewService:QualityControlReviewService
  ){}

  ngOnInit(): void {
    this.loadExportDocumentType()
    this._activatedRoute.params.subscribe(params => {
      this.orderGuid = params['orderId']
      this.loadDocuments()
      this.loadImportOrder()
    })
  }

  changeActiveTab(newActiveTab: number) {
    this.tabActiveIndex = newActiveTab;
  }

// @HostListener('document:dragover', ['$event'])
// onGlobalDragOver(event: DragEvent) {
//   // No uses stopPropagation aquí
//   event.preventDefault(); // solo evita la acción por defecto (navegar)
// }

// @HostListener('document:drop', ['$event'])
// onGlobalDrop(event: DragEvent) {
//   // Esto también evita navegación
//   event.preventDefault();
// }

  loadExportDocumentType() {
    this.operationDocumentTypes =  []
    this._operationDocumentTypeService.getAll().subscribe({
      next: (v) => {
        this.operationDocumentTypes = v
        this.loading = false
      },
      error: (e) => {
        this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: this.translate.instant('MessageService.ExportOfferDocument.ManyRetrieveError') });
        console.log(e)
        this.loading = false
      },
      complete: () =>  {
        this.loading = false
        console.info('Operation Document types query successfully')
      }
    })
  }

  onSelect(event: any) {
    this.uploadedFiles = []
    this.names = []
    this.documentTypes = []
    for(let file of event.files) {
        this.uploadedFiles.push(file);
        this.names.push(file.name)
        if(!event.removeItem)
        {
          this.uploadDialog()
        }
    }

    // if(event.files[0])
    //   this.name = event.files[0].name
  }

    onRemove(event: any, uploader: any) {
      this.uploadedFiles = []
      this.names = []
      this.documentTypes = []
      for(let file of uploader.files) {
        this.uploadedFiles.push(file);
        this.names.push(file.name)
      }
  }

  uploadDialog()
  {
    if(this.uploadedFiles.length > 0)
    {
      this.visibleFilesModal = true;
    }
  }

  upload(){
    this.loading = true
    if (!this.documentTypeId) {
      this.loading = false;
      this._messageService.add({ severity: 'error', summary: 'Acción fallida', detail: 'Debe seleccionar tipo de documento' })
      return;
    }

    if(!this.uploadedFiles[0]){
      this.loading = false;
      this._messageService.add({ severity: 'error', summary: 'Acción fallida', detail: 'Por favor cargue un documento' })

    }else{
      const uploadFileRequest: UploadOperationFileRequest = {
        orderId: this.orderGuid ? this.orderGuid: 0,
        name: this.name,
        pdf: this.uploadedFiles[0],
        operationDocumentTypeId: this.documentTypeId
      }
      this._operationService.uploadFile(uploadFileRequest).subscribe({
        next: (v) => {
          this._messageService.add({ severity: 'success', summary: 'Confirmed', detail: 'Se registró el documento correctamente.' })
          this.loading = false
          this.loadDocuments()
        },
        error: (e) => {
          this.loading = false
          console.log(e)
          this._messageService.add({ severity: 'error', summary: 'Acción fallida', detail: 'No se pudo recuperar el documento.' });
        },
        complete: () => {
          this.loading = false
          console.log('Se registró el documento correctamente.')
        }
      })
    }

  }

  uploadMultiple()
  {
    this.loading = true
    if(!this.validTypes())
    {
      this.loading = false;
      this._messageService.add({ severity: 'error', summary: 'Acción fallida', detail: 'Debe seleccionar tipo de documento en cada archivo' })
      return;
    }

    if(!this.validNames())
    {
      this.loading = false;
      this._messageService.add({ severity: 'error', summary: 'Acción fallida', detail: 'Debe ingresar un nombre en cada documento' })
      return;
    }

    let documentTypesId: number[] = this.documentTypes.map(x => x.documentTypeId);
    this._operationService.uploadFileMultiple(this.uploadedFiles, this.names, documentTypesId, this.orderGuid ? this.orderGuid: 0 ).subscribe({
        next: (v) => {
          this._messageService.add({ severity: 'success', summary: 'Confirmed', detail: 'Se registraron los documentos correctamente.' })
          this.loading = false
          this.visibleFilesModal = false;
          this.loadDocuments()

          this.changeActiveTab(1);
        },
        error: (e) => {
          this.loading = false
          console.log(e)
          this._messageService.add({ severity: 'error', summary: 'Acción fallida', detail: 'Error al cargar los documentos.' });
        },
        complete: () => {
          this.loading = false
          console.log('Se registró el documento correctamente.')
        }
      })

  }

  validNames(): boolean
  {
    if(this.names.length == 0){

        return false;
    }

    let noEmptyName = true
    this.names.forEach(x => {
      if(!x || x.trim() === '')
      {
        noEmptyName = false;
      }
    })

    return noEmptyName;
  }

  validTypes(): boolean
  {
    if(this.documentTypes.length == 0){

      return false;
    }


    if(this.documentTypes.length != this.uploadedFiles.length)
    {
      return false
    }else{
      return true;
    }
  }

  loadImportOrder()
  {
    if(this.orderGuid)
    {
      this.loading = true
      this._importOrderService.getById(this.orderGuid).subscribe(
        {
          next: (v) => {
            this.order = v;
            this.orderId = v.importOrder.sequence;
            this.loading = false
          },
          error: () => {
          this.loading = false
          this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: 'Failed retrieving sale program'});
        }
        }
      )

    }
  }

  goToOrderDetail() {
    this._router.navigate(['/' + Routes.adminOrderManagement, this.orderGuid])
  }

  onSelectDocumentType(event: any) {
    this.documentTypeId = event.value
  }

  onSelectDocumentTypeMultiple(event: any, index: number) {
    let elementIndex = this.documentTypes.findIndex(x => x.index == index)
    if(elementIndex != -1)
    {
      this.documentTypes[elementIndex].documentTypeId = event.value;

    }else{
      this.documentTypes.push({
        index: index,
        documentTypeId: event.value
      })
    }

    this.documentTypes.sort((a) => a.index )
  }

  onDelete(guid: string) {
    this._confirmationService.confirm({
      message: '¿Está seguro de eliminar este documento?',
      header: 'Eliminar documento',
      icon: 'pi pi-info-circle',
      accept: () => {
        this._operationService.deleteDocument(guid).subscribe({
          next: (v) => {
            this._messageService.add({ severity: 'info',
              summary: this.translate.instant('MessageService.Summary.SuccessAction'),
              detail: 'Se eliminó el documento exitosamente.' })
              this.loadDocuments()
          },
          error: (e) => {
            console.log(e)
            this._messageService.add({ severity: 'error',
              summary: this.translate.instant('MessageService.Summary.FailedAction'),
              detail: 'No se pudo eliminar el documento.' });
          }
        })
      },
      reject: (type: any) => {
          switch (type) {
              case ConfirmEventType.REJECT:
                  //this._messageService.add({ severity: 'error', summary: 'Rejected', detail: 'Se canceló la eliminación' })
                  break;
              case ConfirmEventType.CANCEL:
                  //this._messageService.add({ severity: 'warn', summary: 'Cancelled', detail: 'Se canceló la eliminación' })
                  break;
          }
      }
    })
  }

  loadDocuments()
  {

    this._operationService.getByImportOrderId(this.orderGuid).subscribe({
      next: (v) => {
        this.operationInformation = v
        this.documents = this.operationInformation.documents
        this.documentsHistory = this.operationInformation.documentsHistory
      },
      error: (e) => {
        this._messageService.add({ severity: 'error', summary: 'Acción fallida', detail: 'No se pudieron recuperar los pagos.' });
      },
      complete: () => {
        console.info('Operation query successfully')
      }
    })
  }

  getOperationDocument(documentId: string) {
    this._documentService.getOperationDocument(documentId).subscribe((resultBlob: any) => {
      var downloadURL = window.URL.createObjectURL(resultBlob.body);
      window.open(downloadURL);
    })
  }

  ValidateDocument(documentGuid: string, isForwarderDocument: boolean, isQcDocument: boolean)
  {
    if(isForwarderDocument)
    {
      this.validateImportOrderDocument(documentGuid);
    }
    else if(isQcDocument)
    {
      this.validateQcReview(documentGuid)
    }else{
      this.validateOperationDocument(documentGuid);
    }
  }

  validateImportOrderDocument(documentGuid: string)
  {
    this.loading = true;
    this._importOrderDocumentService.validateImportDocument(documentGuid).subscribe({
      next: (v) => {
        this.loading = false;
        if(v)
        {
          this._messageService.add({
            severity: 'success', summary: 'Acción exitosa',
            detail: 'Proceso de validación terminado.'
          });
        this.loadDocuments()
        }else{
            this._messageService.add({
            severity: 'warn', summary: 'Proceso completado sin resultados',
            detail: 'No se encontraron palabras claves para este tipo de archivo.'
          });
        }

      },
      error: (e) => {
        this.loading = false;
        this._messageService.add({ severity: 'error', summary: 'Acción fallida', detail: 'Error al leer documentos.' });
      }
    })
  }

  validateQcReview(documentGuid: string)
  {
    this.loading = true;
    this._qualityControlReviewService.validateQualityControlReview(documentGuid).subscribe({
      next: (v) => {
        this.loading = false;
        if(v)
        {
          this._messageService.add({
            severity: 'success', summary: 'Acción exitosa',
            detail: 'Proceso de validación terminado.'
          });
        this.loadDocuments()
        }else{
            this._messageService.add({
            severity: 'warn', summary: 'Proceso completado sin resultados',
            detail: 'No se encontraron palabras claves para este tipo de archivo.'
          });
        }
      },
      error: (e) => {
        this.loading = false;
        this._messageService.add({ severity: 'error', summary: 'Acción fallida', detail: 'Error al leer documentos.' });
      }
    })
  }

  validateOperationDocument(documentGuid: string)
  {
    this.loading = true;
    this._operationDocumentTypeService.validateOperationDocument(documentGuid).subscribe({
      next: (v) => {
        this.loading = false;
        if(v)
        {
          this._messageService.add({
            severity: 'success', summary: 'Acción exitosa',
            detail: 'Proceso de validación terminado.'
          });
        this.loadDocuments()
        }else{
            this._messageService.add({
            severity: 'warn', summary: 'Proceso completado sin resultados',
            detail: 'No se encontraron palabras claves para este tipo de archivo.'
          });
        }
      },
      error: (e) => {
        this.loading = false;
        this._messageService.add({ severity: 'error', summary: 'Acción fallida', detail: 'Error al leer documentos.' });
      }
    })
  }

  openResults(log: string | null
  )
  {
    // console.log(documentResult)
    // this.results = []
    // this.selectedDocumentResult = documentResult;
    // if(documentResult.keywordResults)
    // {
    //   documentResult.keywordResults.results.forEach(x => {
    //     this.results.push(x);

    //   })
    // }

    this.log = log;
    this.visibleKeywordResult = true;
  }

  onDocumentSelectionWithTypesChanged(selectedDocsWithTypes: Array<{documentId: number, documentTypeId: number}>) {
    this.selectedDocumentsWithTypes = selectedDocsWithTypes;
  }

  closeDocumentAssignModal() {
    this.visibleDocumentAssignModal = false;
    this.selectedDocumentsWithTypes = [];
  }

  assignSelectedDocuments() {
    if (this.selectedDocumentsWithTypes.length === 0) {
      this._messageService.add({
        severity: 'warn',
        summary: 'Advertencia',
        detail: 'Debe seleccionar al menos un documento para asignar.'
      });
      return;
    }

    // Validar que todos los documentos tengan un tipo seleccionado
    const documentsWithoutType = this.selectedDocumentsWithTypes.filter(item => !item.documentTypeId);
    if (documentsWithoutType.length > 0) {
      this._messageService.add({
        severity: 'error',
        summary: 'Error de validación',
        detail: 'Todos los documentos seleccionados deben tener un tipo de documento asignado.'
      });
      return;
    }

    // Validar que existe orderId
    if (!this.order) {
      return;
    }

    const request: OperationAssignDocumentsRead = {
      orderId: this.order.importOrder.guid,
      documentRequestAssigns: this.selectedDocumentsWithTypes.map(({ documentId, documentTypeId }) => ({
        documentId: documentId,
        operationDocumentTypeId: documentTypeId
      }))
    }

    this._operationService.assignDocumentsRead(request).subscribe({
      next: () => {
        this._messageService.add({
          severity: 'success',
          summary: 'Éxito',
          detail: 'Documentos asignados correctamente.'
        });
        this.visibleDocumentAssignModal = false;
        this.selectedDocumentsWithTypes = [];

        this.changeActiveTab(1);
        this.loadDocuments();
      },
      error: () => {
        this._messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al asignar los documentos.'
        });
      }
    });
  }

  setSelectedDocumentType(document: OperationDocument, documentTypeId: number) {
    if (documentTypeId) {
      this.loading = true;
      this._operationService.updateDescription(
        document.guid,
        document.description ?? '-',
        document.isForwarderDocument!,
        document.isQcDocument!,
        documentTypeId
      ).subscribe({
        next: () => {
          this.loading = false;

          this._messageService.add({
            severity: 'success',
            summary: 'Éxito',
            detail: 'Tipo de documento actualizado correctamente.'
          });

          this.loadDocuments();
        },
        error: () => {
          this.loading = false;
          this._messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudo actualizar el tipo de documento.'
          });
        }
      });
    }
    else {
      this._messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'No se encontró el tipo de documento.'
      });
    }
  }
}
